/** Figma WIZ-3 add-element chips (nodes 463:14561 / 463:14714). */
export const PLACEMENT_CHIPS = [
    { type: 'SIGNATURE', label: 'Signature', glyph: '✎' },
    { type: 'INITIALS', label: 'Initials', glyph: 'AB' },
    { type: 'MULTI_SELECT', label: 'Checkbox', glyph: '☐' },
    { type: 'SINGLE_SELECT', label: 'Single select', glyph: '◉' },
    { type: 'DATE_INPUT', label: 'Date signed', glyph: '31' },
    { type: 'TEXT_INPUT', label: 'Printed name', glyph: 'Aa' },
];
export const ROLE_SWATCH = {
    'participant': '#4F46E5',
    'third party': '#15803D',
    'internal signer': '#CA8A04',
};
export const roleSwatchColor = (signerTypeId) => ROLE_SWATCH[signerTypeId ?? ''] ?? '#6B7280';
